<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="上传发票" width="75%" top="5vh" :visible.sync="dialogVisible" :show-close="true" :close-on-click-modal="false" destroy-on-close>
        
      <el-row style="min-height: 600px;">

        <el-col :span="7">
          <el-upload drag :multiple="false" ref="fileRef" action="#" accept=".pdf,image/jpg,image/jpeg,image/png" :auto-upload="false" :limit="1" :on-remove="removeData" :on-change="handleChange">
            <div class="el-upload__text" style="line-height: 60px;">
                将文件拖到此处，或<em>点击上传</em> (只能上传图片或PDF文件)
            </div>
          </el-upload>
          <el-card class="box-card" shadow="never" size="mini">
            <div slot="header" class="clearfix">
              <span>发票详情</span>
            </div>
            <el-table :data="detailList" height="490" style="width: 100%" size="mini" :show-header="false">
              <el-table-column prop="name" label="属性" width="120" show-overflow-tooltip>
                <template scope="scope">
                    <span style="font-weight: 600;font-size: 14px;">{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="value" label="值" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="16" style="margin-left: 10px;padding: 5px;border: 2px #66666626 dashed;  min-height: 600px;">
          <el-carousel trigger="click" :autoplay="false" style="min-height: 600px;" @change="carouselChange">
            <el-carousel-item v-for="item in viewList" :key="item">
              <el-empty v-if="item.fileId == null || item.fileId == ''" description="无数据"></el-empty>
              <el-image v-else style="height: 600px;" :src="getFilePath(item.fileId)" fit="fill"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>

      </el-row>
        
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="saveInvoiceInfo()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { Message,MessageBox } from 'element-ui';
import { uploadInvoiceFile,saveInvoiceInfo } from "@/api/invoice";

export default {
  name: "UploadInvoiceDialog",
  props: {
    dialogVisible: false
  },
  data(){
    return {
      rules: {},
      loading:false,
      img : null,
      viewList: [],
      detailList: [],
      saveData : []
    }
  },
  mounted(){

  },
  created() {
    
  },
  watch : {

    dialogVisible(newObj,oldObj){
        this.viewList = [];
        this.detailList = [];
        this.saveData = [];
    }
    
  },
  methods: {

    removeData(){
        this.viewList = [];
        this.detailList = [];
        this.saveData = [];
    },
    
    //图片地址
    getFilePath(fileId){
       let url = window.location.origin;
       return url + '/api/common/image/preview?fileId=' + fileId;
    },
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },

    //上传发票
    handleChange(){
      let this_ = this;
      let file = this.$refs.fileRef.uploadFiles[0];
      this.loading = true;
      uploadInvoiceFile(file.raw).then(res => {
          if(res.data.code == 200){
              this_.saveData = res.data.data;
              this_.parseInvoiceList(this_.saveData);
          } else {
              Message.error(res.data.msg);
          }
          this.loading = false;
      });
    },

    //解析发票
    parseInvoiceList(list){
      let viewList_ = [];
      this.detailList = [];
      list.forEach(element => {
          let valObj = element.invoiceEditDto.invoice;
          let fileId = valObj.fileId;
          if(valObj.existInvoice != 'true'){ 
            let labelList = [];
            element.nameMap.forEach(nm => {
                let val_ = valObj[nm.base_value];
                if(val_ != null && val_ != ''){
                    labelList.push({'name':nm.base_name,'value':val_});
                }
            });
            if(labelList.length > 0){
               viewList_.push({'labelList': labelList ,'fileId': fileId }); 
            }
          }
      });
      this.viewList = viewList_;
      if(viewList_.length > 0){
         this.detailList = viewList_[0].labelList;
      }
      if(viewList_.length == 0){
          Message.warning('发票已存在，请重新上传发票.');
      }
    },

    //发票切换
    carouselChange(val){
        this.detailList = this.viewList[val].labelList;
    },

    //发票保存
    saveInvoiceInfo(){
        let this_ = this;
        let data = this.saveData;
        if(data && data.length > 0){
           saveInvoiceInfo(data).then(res => {
               if(res.code == 200){
                    Message.success('操作成功');
                    this_.$emit('close');
               } else {
                   Message.error(res.msg);
               }
           })
        }
    },

  
  },
};
</script>

<style>
.znk_form_item {
  margin-bottom: 5px !important;
}
.el-upload-dragger {
  width: 100% !important;
}
.el-upload {
  width: 100% !important;
}
.invoice-text-item {
    line-height: 35px;
    height: 35px !important;
    border-bottom: 1px #66666630 dashed;
}
.el-upload-dragger {
   height: 60px;
}
.el-card__header {
    padding: 10px 10px;
    font-size: 14px;
    font-weight: 600;
}
.el-card__body {
    padding: 10px;
}
.text-over {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-carousel__container {
   min-height: 600px;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/UploadInvoiceDialog.vue